import { CircleCheck, CircleX } from 'lucide-react';
import { useEffect } from 'react';

interface ToastProps {
  setShow: Function;
  message: string;
  variant: 'success' | 'warn' | 'error';
  header?: string;
  className?: string;
}

export default function ToastAlert({
  setShow,
  message,
  variant = 'success',
  header,
  className,
}: Readonly<ToastProps>) {
  useEffect(() => {
    setTimeout(() => {
      setShow(false);
    }, 5000);
  });

  let styles = 'bg-teal-100 border border-teal-200 text-sm text-teal-800';

  switch (variant) {
    case 'success':
      break;
    case 'error':
      styles = 'bg-red-100 border border-red-200 text-sm text-red-800';
      break;
    case 'warn':
      styles = 'bg-yellow-100 border border-yellow-200 text-sm text-yellow-800';
      break;
    default:
      break;
  }

  return (
    <div className={`absolute bottom-6 right-6`}>
      <div className={`my-2 w-full rounded-lg ${styles} ${className}`}>
        <div className="flex p-4 items-start gap-5">
          <div>
            {variant == 'success' && <CircleCheck className="size-6" />}
            {variant == 'error' && <CircleX className="size-6" />}
          </div>
          <div className="gap-y-3">
            {header && <h3 className="text-lg font-semibold">{header}</h3>}
            <p className="text-base leading-6">{message}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
